import { API } from "../../api/Api";

export type AutoloadClientOsType = "linux" | "osx" | "win" | "win32";

export const getAutoloadClientDownloadURL = (os: AutoloadClientOsType, disableTLSValidation: boolean, api: API) => {
  const { hostname, port, protocol } = api.getUrlComponents();
  return `${protocol}//${hostname}:${port}/${api.getGroup()}/api/0.1/autoload_client_api/download_client_zip?platform=${os}&disable_tls_validation=${disableTLSValidation}`;
};
